// extracted by mini-css-extract-plugin
module.exports = {"base-fade-up":"base-fade-up__2ml7X","animate-fade-up":"animate-fade-up___vmtD"};